<template>
  <div class="rn-team-area team-area rn-section-gap bg_color--1">
    <v-container>
      <!-- <v-row class="row">
      <v-col cols="12">
        <div class="section-title text-center mb--30">
          <h2>Cónoce nuestro equipo</h2>
          <p>
            There are many variations of passages of Lorem Ipsum available,
            <br />
            but the majority have suffered alteration.
        </p>
        </div>
      </v-col>
    </v-row> -->
      <v-row class="mt--30">
        <!-- Start Single Team Area  -->
        <v-col :cols=comNumColumnas v-for="team in NOTARIA.Team" :key="team.id">
          <div class="team-card team-static">
            <div class="thumbnail" v-if="team.Imagen">
              <img :src="imagenIDtoSRC(team.Imagen)" :alt="'Fotografía de ' + team.Nombre" />
            </div>
            <div class="inner">
              <div class="content">
                <h3 v-if="team.Nombre">{{ team.Nombre }}</h3>
                <h4 v-if="team.Puesto">{{ team.Puesto }}</h4>
                <p v-if="team.Descripcion">{{ team.Descripcion }}</p>
                <p v-if="team.Extension">Extensión - {{ team.Extension }}</p>
                <a :href="'mailto:' + team.Email" v-if="team.Email" :title="'Enviar email a ' + team.Nombre">
                  <v-icon focusable="false" :color="NOTARIA.Theme.Team.Tarjeta.Titulo.css.Color">
                    mdi-email
                  </v-icon>
                </a>
              </div>
            </div>
          </div>
        </v-col>
        <!-- End Single Team Area  -->
      </v-row>
    </v-container>
  </div>
</template>
<script setup lang="ts">
import { useStore } from '../../store/index'
const { NOTARIA } = useStore()
import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()
import { useStyles } from '../../store/styles';
const style = useStyles();

const comNumColumnas = computed(() => {
  if (NOTARIA.Theme.Team.NumeroColumnas == 1) {
    return 12
  } else if (NOTARIA.Theme.Team.NumeroColumnas == 2) {
    return 6
  } else if (NOTARIA.Theme.Team.NumeroColumnas == 3) {
    return 4
  } else if (NOTARIA.Theme.Team.NumeroColumnas == 4) {
    return 3
  }
})
const estiloTarjetaTituloColor = style.ThemeSectionTeam.Tarjeta.Titulo.css.Color
const estiloTarjetaTituloShadow = style.ThemeSectionTeam.Tarjeta.Titulo.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionTeam.Tarjeta.Titulo.css.BackgroundColor:""
const estiloTarjetaTituloFont = style.ThemeSectionTeam.Tarjeta.Titulo.css.Font
const estiloTarjetaTituloSize = style.ThemeSectionTeam.Tarjeta.Titulo.css.Size
const estiloTarjetaTituloWeight = style.ThemeSectionTeam.Tarjeta.Titulo.css.Weight
const estiloTarjetaTituloAlign = style.ThemeSectionTeam.Tarjeta.Titulo.css.Align

const estiloTarjetaDescripcionColor = style.ThemeSectionTeam.Tarjeta.Descripcion.css.Color
const estiloTarjetaDescripcionShadow = style.ThemeSectionTeam.Tarjeta.Descripcion.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionTeam.Tarjeta.Descripcion.css.BackgroundColor:""
const estiloTarjetaDescripcionFont = style.ThemeSectionTeam.Tarjeta.Descripcion.css.Font
const estiloTarjetaDescripcionSize = style.ThemeSectionTeam.Tarjeta.Descripcion.css.Size
const estiloTarjetaDescripcionWeight = style.ThemeSectionTeam.Tarjeta.Descripcion.css.Weight
const estiloTarjetaDescripcionAlign = style.ThemeSectionTeam.Tarjeta.Descripcion.css.Align

</script>


<style lang="scss">
  .team-card h3, .team-card h5{
    color:v-bind(estiloTarjetaTituloColor)  !important;
    text-shadow:v-bind(estiloTarjetaTituloShadow)  !important;
    font-size:v-bind(estiloTarjetaTituloSize) !important;
    font-family: v-bind(estiloTarjetaTituloFont) !important;
    font-weight:v-bind(estiloTarjetaTituloWeight) !important;
    text-align:v-bind(estiloTarjetaTituloAlign)  !important;
  }
  .team-card p, .team-card h4{
    color:v-bind(estiloTarjetaDescripcionColor)  !important;
    text-shadow:v-bind(estiloTarjetaDescripcionShadow)  !important;
    font-family:v-bind(estiloTarjetaDescripcionFont)  !important;
    font-size: v-bind(estiloTarjetaDescripcionSize)  !important;
    font-weight:v-bind(estiloTarjetaDescripcionWeight) !important;
    text-align:v-bind(estiloTarjetaDescripcionAlign)  !important;
  }
  .team-card a{
    color:v-bind(estiloTarjetaTituloColor)  !important;
  }

</style>

